module.exports = __webpack_public_path__ + "static/img/1.74ffb16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/1.png
// module id = u0u/
// module chunks = 0